import {
  INIT_PANELS,
  INIT_GRIDS,
  INIT_MODALS,
  CLOSE_MODALS,
  RESET_MODALS,
  SET_MODALS_PARAM,
  SET_PARAM_PANELS,
  SET_GRIDS_PARAM,
  UPDATE_PANELS,
  SET_LOCALE,
} from "../action/comAction";

/*
 *  Panels信息状态
 *  @param openPanels {Array} 打开的Tab 页面组
 *  @param panelsReducer {Function} 管理Tab状态函数
 *
 * */

const Panels = {
  key: "",
  openPanels: [],
  activeKey: null,
  param: "",
};

const Grids = {
  param: {},
  fetchDataHandler: null,
  context: {},
};

const Modals = {
  key: "",
  visible: !1,
  param: {},
  modalHandles: {
    reset: [],
  },
  render: !0, // 是否进行渲染
  context: null,
};

// 'zh'--中文
// 'en'--英文
// 'es'--西班牙语
// console.log(navigator.language);
// let navLanguage = null;
// if (navigator.language === "zh-CN") {
//   navLanguage = "zh";
// } else if (navigator.language === "es-ES") {
//   navLanguage = "es";
// } else {
//   navLanguage = "en";
// }

// 默认为zh
// navLanguage = "zh";

const initState = {
  // locale: window.sessionStorage.getItem('locale')
  // ?window.sessionStorage.getItem('locale'):navLanguage
  locale: "zh",
};
console.log(navigator.language);

const panelsReducer = (state = Panels, action = { type: "" }) => {
  switch (action.type) {
    case INIT_PANELS:
      return {
        ...state,
        key: action.key,
        openPanels: [...Panels.openPanels, ...action.tab],
        activeKey: action.activeKey,
        param: action.param,
      };
    case UPDATE_PANELS:
      return {
        ...state,
        openPanels: [...action.panels],
        activeKey: action.activeKey,
      };
    case SET_PARAM_PANELS:
      return {
        ...state,
        key: action.key,
        param: action.param,
      };
    default:
      return state;
  }
};

const gridsReducer = (state = Grids, action = { type: "" }) => {
  let returnValue;
  const newContext = {};
  switch (action.type) {
    case INIT_GRIDS:
      newContext[action.key] = action.context;
      Grids.context = { ...Grids.context, ...newContext };
      returnValue = {
        ...state,
        param: action.param,
        fetchDataHandler: action.handler,
        context: Grids.context,
      };
      break;
    case SET_GRIDS_PARAM:
      Grids.param = { ...Grids.param, ...action.param };
      returnValue = {
        ...state,
        param: Grids.param,
      };
      break;
    default:
      returnValue = state;
      break;
  }
  return returnValue;
};

const modalsReducer = (state = Modals, action = { type: "" }) => {
  console.log(state, action);
  switch (action.type) {
    case INIT_MODALS:
      return {
        ...state,
        key: action.key,
        visible: action.visible,
        param: action.param,
        render: !0,
        context: action.context,
      };
    case CLOSE_MODALS:
      return {
        ...state,
        // key: '',
        render: !0,
        visible: action.visible,
      };
    case RESET_MODALS:
      return {
        ...state,
        key: action.key,
        render: !1,
        modalHandles: {
          ...state.modalHandles,
          reset: [...state.modalHandles.reset, action.handler], // 注入重置事件
        },
      };
    case SET_MODALS_PARAM:
      return {
        ...state,
        key: action.key,
        render: !1,
        param: action.param,
      };
    default:
      return state;
  }
};

// 国际化配置

const appReducer = (state = initState, action = { type: "" }) => {
  // 国际化
  if (action.type === SET_LOCALE) {
    return {
      ...state,
      locale: action.locale,
    };
  } else {
    return state;
  }
};

const comReducer = {
  panelsInfo: panelsReducer,
  gridsInfo: gridsReducer,
  modalInfo: modalsReducer,
  appLocalInfo: appReducer,
};

export default comReducer;



// WEBPACK FOOTER //
// ./src/AntD/state/reduce/comReducer.js